import styled from 'styled-components';

import { IOcAppTheme } from '../../config/ocTheme';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Label = styled.label`
  ${({ theme }) =>
    (theme as IOcAppTheme).color.askHumanFormLabel
      ? `color: ${(theme as IOcAppTheme).color.askHumanFormLabel};`
      : ''}
`;

export const RequiredIndicator = styled.span`
  color: ${({ theme }) => theme.color.errorIcon};
`;

export const LoadingText = styled.div`
  padding: 0.5rem 0.75rem;
`;

export const ErrorText = styled.div`
  padding: 0.5rem 0.75rem;
  font-size: ${({ theme }) => theme.font.size.medium};
  color: ${({ theme }) => theme.color.errorIcon};
`;

export const Select = styled.select<{ $hasError?: boolean }>`
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  border-radius: 4px;
  border: 1px solid
    ${({ theme, $hasError }) =>
      $hasError ? theme.color.errorIcon : theme.color.chatBorder};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};

  &:disabled {
    cursor: not-allowed;
  }
`;

export const Input = styled.input<{ $hasError?: boolean }>`
  padding: 0.5rem 0.75rem;
  border-radius: 4px;
  border: 1px solid
    ${({ theme, $hasError }) =>
      $hasError ? theme.color.errorIcon : theme.color.chatBorder};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'text')};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
`;

export const FieldError = styled.span`
  font-size: ${({ theme }) => theme.font.size.small};
  color: ${({ theme }) => theme.color.errorIcon};
  margin-top: 0.25rem;
`;
